/*
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-30 14:56:16
 */
import { formatDateTime, formatImg, formatCurrency } from "@utils/tools";

/* 表单验证 */
/* form 序号验证 ： 非必填 */
// export const isEmail = (rule, value, callback) => {
//     if (value != '') { // 不为空的时候进行验证
//         validate.isEmail(value) ? callback() : callback(new Error('邮箱格式错误'))
//     } else { // 为空的时候就直接放过去（这里一定要写，不然既不报错也不会往下走【应该和router的next()相同】）
//         callback()
//     }
// };

/**
 * 图片地址格式化
 * @param {*} rawImg 图片地址
 */
export const formatImage = (rawImg) => {
    return formatImg(rawImg);
};

/**
 * 日期时间过滤
 * @param {*} dateTime 日期时间
 * @param {*} forma  格式
 * @returns {string}
 */
export const formatDate = (dateTime, format) => {
    return formatDateTime(dateTime, format);
};

/**
 * 格式化货币，保留2位小数
 * @param num 数值(Number或者String)
 * @return 金额格式的字符串,如'1,234,567.45'
 * @type String
 */
export const formatMoney = (dateTime, format) => {
    return formatCurrency(dateTime, format);
};
